<template>
  <div id="tokido" class="interview-item" @click="onInterviewClick">
    <div class="interview-item__in">
      <div
        class="tokido"
        data-scroll
        :data-scroll-speed="$store.state.isMobile ? -2.2 : 1.5"
        data-scroll-delay="0.05"
        data-scroll-target="#tokido"
      >
        <picture>
          <source type="image/webp" srcset="@/assets/mv-tokido.webp" />
          <img class="person" src="@/assets/mv-tokido.png" alt="" />
        </picture>
      </div>

      <svg
        class="tri-02"
        data-scroll
        data-scroll-speed="1"
        data-scroll-target="#tokido"
        width="526"
        height="351"
        viewBox="0 0 526 351"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M525.676 18.0464L21.522 73.7057L21.984 336.246L525.676 18.0464Z"
          fill="white"
        />
      </svg>

      <svg
        class="tri-03"
        data-scroll
        data-scroll-speed="-1.8"
        data-scroll-direction="horizontal"
        data-scroll-target="#tokido"
        width="1054"
        height="505"
        viewBox="0 0 1054 505"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M4.19713 492.741L779.985 371.066L1053.54 -5.82613e-06L4.19713 492.741Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="1054" height="505" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <div class="interview-item__body">
        <div class="name__wrap">
          <span class="name__number">02</span>
          <div class="name__col">
            <span class="name__role">eスポーツプレイヤー</span>
            <span class="name__text">ときど</span>
          </div>
        </div>
        <img
          class="copy"
          src="@/assets/tokido-copy.png"
          alt="格ゲーは 「どう生きてるか」 のぶつけ合い人生をかけ 最強 を追い求めるプロゲーマー・ときど"
        />

        <c-button label="インタビューを見る" color="white" />
      </div>
      <div class="interview-item__name-wrap">
        <span
          data-scroll
          data-scroll-direction="horizontal"
          data-scroll-speed="9"
          data-scroll-delay="0.05"
          data-scroll-target="#tokido"
          class="interview-item__name"
          >TOKIDO TOKIDO TOKIDO</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import scrollTrigger from '@/mixins/scrollTrigger.js'
import CButton from '@/components/C-Button.vue'

export default {
  mixins: [scrollTrigger],

  components: { CButton },

  methods: {
    async onInterviewClick() {
      if (this.$route.params.name !== 'tokido') {
        const { dispatch } = this.$store
        dispatch('debounceRouterPush', '/interview/tokido')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.interview-item {
  height: 70rem;
  overflow: hidden;
  transform: skewY(-6deg);
  transform-origin: 0 0;
  background: linear-gradient(to left, #e70013, #bd0414);

  @media screen and (max-width: $breakpoint-mobile) {
    height: 60rem;
  }
  &__in {
    position: relative;
    height: 70rem;
    transform: skewY(6deg);
    @media screen and (max-width: $breakpoint-mobile) {
      height: 60rem;
    }
  }

  .tokido {
    position: absolute;
    left: 3rem;
    top: 5rem;

    @media screen and (max-width: $breakpoint-mobile) {
      top: 8rem;
      left: -2rem;
    }

    .tag {
      position: absolute;
      top: 40rem;
      left: 10rem;
      @media screen and (max-width: $breakpoint-mobile) {
        top: 17rem;
        left: 22rem;
      }
    }

    .person {
      width: 120rem;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 66rem;
      }
    }
  }

  &__body {
    position: absolute;
    top: 50%;
    right: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 50%;
    transform: translate(0%, -60%);
    @media screen and (max-width: $breakpoint-mobile) {
      width: 100%;
      top: inherit;
      bottom: 0;
      transform: translate(0, 0);
    }

    .name {
      &__wrap {
        display: flex;
        align-items: center;
        color: #fff;
        transform: skewY(-6deg);
        @media screen and (max-width: $breakpoint-mobile) {
          margin: 0 0 1rem;
        }
      }

      &__number {
        font-size: 8rem;
        font-weight: 800;
        line-height: 1;
        opacity: 0.3;
        padding: 0 0 0.1em;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 4.4rem;
          opacity: 1;
          filter: drop-shadow(2px 4px 6px var(--main-color));
        }
      }

      &__col {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0 0 0 2rem;
      }

      &__role {
        font-size: 2rem;
        margin: 0 0 1.2rem;
        font-weight: 800;
        line-height: 1;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 1.7rem;
          margin: 0 0 0.8rem;
          filter: drop-shadow(2px 4px 6px var(--main-color));
        }
      }

      &__text {
        font-size: 5.8rem;
        font-weight: 800;
        line-height: 1;
        @media screen and (max-width: $breakpoint-mobile) {
          font-size: 4.2rem;
          filter: drop-shadow(2px 4px 6px var(--main-color));
        }
      }
    }

    .copy {
      width: 80rem;
      margin: -2rem 0 0;
      backface-visibility: hidden;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        margin: 0;
      }
    }
    .c-button {
      margin: -5rem auto;
      @media screen and (max-width: $breakpoint-mobile) {
        width: 100%;
        margin: 0 auto;
      }
    }
    .comingsoon {
      font-size: 10rem;
      font-weight: 800;
      color: #fff;
      filter: drop-shadow(2px 4px 6px var(--main-color));
      transform: skewY(-6deg);
      @media screen and (max-width: $breakpoint-mobile) {
        font-size: 14vw;
        margin: 0 0 2rem;
      }
    }
  }
  &__name-wrap {
    position: absolute;
    left: 0;
    top: 15rem;
    transform: skewY(-6deg);
    z-index: -9;
  }

  &__name {
    position: absolute;
    font-size: 40rem;
    font-weight: 900;
    white-space: nowrap;
    color: #ffffff10;
  }

  .tri-01 {
    position: absolute;
    left: -11rem;
    bottom: -17rem;
    width: 70rem;
    height: 49rem;
  }

  .tri-02 {
    position: absolute;
    left: -18rem;
    top: 40rem;
    width: 80rem;
    height: 44rem;
    z-index: -9;
    @media screen and (max-width: $breakpoint-mobile) {
      top: 20rem;
    }
  }

  .tri-03 {
    position: absolute;
    top: -56rem;
    right: -28rem;
    width: 120rem;
    height: 70rem;
    @media screen and (max-width: $breakpoint-mobile) {
      top: 14rem;
      width: 80rem;
    }
  }
}
</style>
